import { createStyles } from "@mantine/emotion";

export const useStylesInput = createStyles((theme) => {
  return {
    number: {
      label: {
        fontSize: theme.spacing.input.number.fontSize,
        marginTop: theme.spacing.input.number.marginTop,
      },
      input: {
        "&:focus": {
          border: "none",
        },
      },
      svg: {
        marginTop: "0",
        top: "0",
      },
    },
  };
});
